import { render } from "./AdminCheckbox.vue?vue&type=template&id=7d0addb6"
import script from "./AdminCheckbox.vue?vue&type=script&lang=js"
export * from "./AdminCheckbox.vue?vue&type=script&lang=js"

import "./AdminCheckbox.vue?vue&type=style&index=0&id=7d0addb6&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__